import { all, call, put, select, takeLatest } from "redux-saga/effects";
import { otp, postAuthToken } from "../../api/apiClient";
import { AUTH_CLIENT_ID, AUTH_RESOURCE_TYPE, REACT_APP_AUTH_API_KEY } from "../../constants";
import { getApplicantInfo, getProspectId, getAuthorizationHeader } from "../selectors/appConfig";
import {
  setGeneratingCode,
  generateCodeSuccess,
  verifyCodeSuccess,
  verifyCodeFailed,
  setOtpPendingRequest,
  GENERATE_OTP_CODE,
  VERIFY_OTP
} from "../actions/otp";
import { setAccessToken } from "../actions/appConfig";
import { log } from "../../utils/loggger";
import { DEVICE_ID } from "../../api/DehAxiosConfig";
import { parseJwt } from "../../utils/genericUtils";

export function* generateOtp(action) {
  try {
    const { headers } = yield select(getAuthorizationHeader);
    // pre-auth endpoint: drop a stale bearer token from a prior verify/token exchange
    delete headers.Authorization;
    headers["stage-id"] = "generateOtp";
    const prospectId = action.payload.prospectId
      ? action.payload.prospectId
      : yield select(getProspectId);
    if (prospectId) {
      headers["prospect-id"] = prospectId;
    }
    yield call(otp.generate, { ...action.payload, prospectId }, { headers });
    yield put(generateCodeSuccess());
  } catch (error) {
    log(error);
  } finally {
    yield put(setGeneratingCode(false));
  }
}

export function* verifyOtp({ payload }) {
  try {
    const { headers } = yield select(getAuthorizationHeader);
    headers["stage-id"] = "verifyOtp";
    const applicantInfo = yield select(getApplicantInfo);
    const selectedSignatoryId = payload.signatoryId;
    const prospectId = payload.prospectId ? payload.prospectId : yield select(getProspectId);
    if (prospectId) {
      headers["prospect-id"] = prospectId;
    }
    const { deviceId: uniqueId = "" } = parseJwt(headers.Authorization);
    const payloadData = {
      email: applicantInfo.email,
      prospectId,
      mobileNo: applicantInfo.mobileNo,
      countryCode: applicantInfo.countryCode ? applicantInfo.countryCode : "",
      otpToken: payload.code,
      signatoryId: payload.signatoryId,
      otpType: payload.otpType,
      deviceId: DEVICE_ID,
      mode: payload.mode,
      uniqueId
    };
    const { data } = yield call(otp.verify, payloadData, { headers });
    if (data.verified) {
      const authTokenData = {
        client_id: AUTH_CLIENT_ID,
        resource_type: AUTH_RESOURCE_TYPE,
        client_secret: process.env.REACT_APP_AUTH_CLIENT_SECRET,
        device_id: DEVICE_ID,
        apiKey: REACT_APP_AUTH_API_KEY,
        unique_id: uniqueId,
        ...(selectedSignatoryId && { sub_resource_id: selectedSignatoryId })
      };
      const { data } = yield call(postAuthToken.get, authTokenData, headers);
      const { access_token = "", refresh_token = "" } = data;
      yield put(setAccessToken(access_token, refresh_token));
      yield put(verifyCodeSuccess());
    } else {
      yield put(verifyCodeFailed());
    }
  } catch (error) {
    log(error);
  } finally {
    yield put(setOtpPendingRequest(false));
  }
}

export default function* otpSagas() {
  yield all([takeLatest(GENERATE_OTP_CODE, generateOtp), takeLatest(VERIFY_OTP, verifyOtp)]);
}
